export const MAX_RECONNECTION_ATTEMPTS = 5;

export const RECONNECT_INTERVAL = 3000;
